import { render, staticRenderFns } from "./Conselhos.vue?vue&type=template&id=8e0786be&scoped=true"
import script from "./Conselhos.vue?vue&type=script&lang=js"
export * from "./Conselhos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0786be",
  null
  
)

export default component.exports